import React from 'react';
import './css/ExploreAsk.scss';
import ASK1 from './images/akc1.png';
import ASK2 from './images/AKC2.png';
import ASK3 from './images/AKC3.png';
import ASK4 from './images/AkC4.png';

const Explore=()=>{
    return(
        <div className="container exploreask">
            <h1 className="Explore-ASKADEMIA">Explore ASKADEMIA</h1>
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img src={ASK1} alt="ASK1" style={{ width:"100%",height:"265px",objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body Rectangle-78">
                            <h5 className="card-title title">Tutoring</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img src={ASK2} alt="ASK2" style={{ width:"100%",height:"265px",objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body Rectangle-78">
                            <h5 className="card-title title">Study Centres</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img src={ASK3} alt="ASK3" style={{ width:"100%",height:"265px",objectFit:"fill",borderTopRightRadius:"12px",borderTopLeftRadius:"12px"}}></img>
                        <div className="card-body  Rectangle-78">
                            <h5 className="card-title title">Blogs</h5>
                            <p className="card-text text">Highlight your teaching and tutoring experience 
                                by featuring them by referring to library .
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div style={{marginTop:"101px",marginBottom:"97px",backgroundColor:"black",overflow:"hidden"}}>
                    <img src={ASK4} alt="ASK4" style={{height:'320px',width:'100%',opacity:0.35,objectFit:"cover"}}></img>
                    <div className="imgText">
                        <div className="Online-tutoring-jobs">Online tutoring jobs</div>
                        <div className="A-selection-of-job-tailored-and-verified-for-you">A selection of job tailored and verified for you</div>
                        <div className="Find-a-tutor-in-any-subject-to-help-you-learn-a-virtual-classroom">Find a tutor in any subject to help you learn a virtual classroom</div>
                        <button className="Rectangle-95">Find Jobs &gt;</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>     
    );
}
export default Explore;